// Types
import { State } from 'types'

export const selectLoopBarPositions = (state: State, trackId: number): Array<number> | null | undefined => {
  const { beatOffset, features: allFeatures } = state.audio
  const features = allFeatures[String(trackId)]
  if (!features) {
    return null
  }
  const beatsPerBar = features.beats_per_bar
  return features.beat_positions.filter((_, index) => index >= beatOffset && (index - beatOffset) % beatsPerBar === 0)
}
